import {Button, styled} from "@mui/material";

const NButtonDark = styled(Button)(({theme}) => ({
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'inherit',
    '&:hover': {
        backgroundColor: theme.info.hover,
        color: 'black'
    },
    fontWeight: 'bold',
}));

export default NButtonDark;